const whiteList = ["/404","/401","/","/loginVerification"]
export default whiteList